import { ChartOptions } from "chart.js";
import { getChartLegendFontConfig } from "../../../utils/charts.utils";
import { formatCurrencyToAda } from "../../../utils/number-format";
import { TTasteTestTargetPriceChartConfig } from "./TasteTestTargetPriceChart";
import { getTasteTestTargetPriceChartTooltips } from "./getChartTooltips";

export const getTasteTestTargetPriceChartOptions = (
  config: TTasteTestTargetPriceChartConfig
): ChartOptions => {
  const { currentLocale, isDark, maxX, minX, responsive } = config;
  const tooltipCallbacks = getTasteTestTargetPriceChartTooltips(config);

  return {
    responsive: true,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    plugins: {
      tooltip: {
        callbacks: tooltipCallbacks,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          color: "transparent",
        },
        min: minX,
        max: maxX,
        type: "time",
        time: {
          unit: "day",
        },
        ticks: {
          ...getChartLegendFontConfig(isDark || false, responsive || {}),
          callback: (value) => {
            return new Intl.DateTimeFormat(currentLocale, {
              month: "short",
              day: "numeric",
            }).format(new Date(value));
          },
        },
      },
      y: {
        grid: {
          color: "transparent",
        },
        ticks: {
          ...getChartLegendFontConfig(isDark || false, responsive || {}),
          callback: (value) => {
            return formatCurrencyToAda(Number(value), currentLocale);
          },
        },
      },
    },
  } as ChartOptions;
};
